<template>
    <div class="full_height_datatable">
      <ag-grid-vue style="width: 100%; height: 100%"
                   class="ag-theme-balham"
                   :gridOptions="gridOptions"
                   :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="rowData"
                   :rowHeight="rowHeight"
                   :animateRows="true"
                   @first-data-rendered="onFirstDataRendered"
                   @row-clicked="onRowClicked"
      >
      </ag-grid-vue>
    </div>
  </template>
  
  <script>
  import {AgGridVue} from "ag-grid-vue";
  
  export default {
    name: "datatable",
    components: {
      AgGridVue
    },
    props: {
      rowData: null,
      columns: null
    },
    data() {
      return {
        gridOptions: null,
        gridApi: null,
        columnApi: null,
        columnDefs: null,
        defaultColDef: null,
        rowHeight: null
      }
    },
    beforeMount() {
      this.gridOptions = {
        suppressCellSelection: true,
        pagination: true,
        paginationPageSize: this.paginationSize,
        rowStyle: {
          'border-bottom': 'white 1px solid',
          'border-top': 'white 1px solid',
        },
        onColumnResized: this.onColumnResized,
      };
  
      this.defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        filterParams: {newRowsAction: 'keep', buttons: ['reset'],},
        cellStyle: {"white-space": "normal"},
        unSortIcon: true,
        suppressMenu: true,
        autoHeight: true,
        suppressSizeToFit: false,
        flex: 1,
        wrapText: true,
      };  
      this.columnDefs = this.columns;
    },
    mounted() {
      this.gridApi = this.gridOptions.api;
      this.gridColumnApi = this.gridOptions.columnApi;
    },
    methods: {
      onRowClicked(params) {
        if(params.data.workerId) {
          this.$nextTick(() => this.$root.$emit('bv::show::modal', params));
        }
      },
      onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
        params.api.resetRowHeights();
      },
      onColumnResized(params) {
        params.api.resetRowHeights();
      }
    },
  }
  </script>
  